import { LANGUAGE_PORTUGUESE } from '../utils/constants';
import { toStringify } from '../utils/smartutils';

export function listAllEmployees() {
  const query = `{
  employeeListByFilter(
    filter: {
      id: 0
      usuarioChatInterno: false
      ativo: true
      filterByStatus: false
      pedagogicAdm: false
      updaterId: 0
      usuarioChat: false
      active: true
    }
  ) {
    id
    name
    cpf
    user
    active
    accessProfiles
    email
  }
}`;
  return query;
}

export function employeeListByFilterQuery(filter) {
  const query = `{employeeListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )})
          {id, 
          name, 
          cpf, 
          rg, 
          zipCode, 
          address, 
          addressNumber, 
          addressAdjunct,
          neighborhood, 
          user, 
          password,
          email,
          comment, 
          cellPhone,
          phone,
          accessProfiles,
          active
          fileId
          fileUrl}}`;
  return query;
}

export function employeeListByFilterWithAccessQuery(filter) {
  const query = `{employeeListByFilterWithAccess(filter: ${JSON.stringify(
    filter
  ).replace(/"([^(")"]+)":/g, '$1:')})
          {id, 
          name, 
          cpf, 
          rg, 
          zipCode, 
          address, 
          addressNumber, 
          addressAdjunct,
          neighborhood, 
          user,
          comment, 
          cellPhone,
          phone,
          accessProfiles,
          active}}`;
  return query;
}

export function saveEmployeeMutation(values) {
  const terms = values.terms
    ? values.terms.map((item) => ({
        ...item.schoolTerm,
        filterByStatus: false,
        updaterId: 0,
      }))
    : [];

  const profiles = values.profiles
    ? values.profiles.map((item) => ({
        ...item.profile,
        filterByStatus: false,
        updaterId: 0,
      }))
    : [];

  const subjects = values.subjects
    ? values.subjects.map((item) => ({
        ...item.subject,
        filterByStatus: false,
        updaterId: 0,
      }))
    : [];

  const channels =
    values.channels && values.channels.length
      ? values.channels.map((item) => ({
          ...item.channel,
          unreadMessageQuantity: 0,
          active: true,
        }))
      : [];

  const groups =
    values.groups && values.groups.length
      ? values.groups.map((item) => ({
          ...item.channel,
          active: true,
          unreadMessageQuantity: 0,
        }))
      : [];

  const classes = values.classes.map((item) => ({
    ...item.class,
    filterByStatus: false,
    updaterId: 0,
  }));

  const mutationQuery = `mutation {
                              employeeSave(                              
                                     employee: {id: ${values.id ? values.id : 0}
                                              , name: "${
                                                values.name
                                              }"                                           
                                              , language: "${LANGUAGE_PORTUGUESE}"
                                              , cpf: "${values.cpf}"
                                              , user: "${values.user}"
                                              , password: "${values.password}"
                                              , rg: "${
                                                values.rg ? values.rg : ''
                                              }"
                                              , zipCode: "${
                                                values.zipCode
                                                  ? values.zipCode
                                                  : ''
                                              }"
                                              , address: "${
                                                values.address
                                                  ? values.address
                                                  : ''
                                              }"
                                              , addressNumber: "${
                                                values.addressNumber
                                                  ? values.addressNumber
                                                  : ''
                                              }"
                                              , addressAdjunct: "${
                                                values.addressAdjunct
                                                  ? values.addressAdjunct
                                                  : ''
                                              }"
                                              , neighborhood: "${
                                                values.neighborhood
                                                  ? values.neighborhood
                                                  : ''
                                              }"                                            
                                              , comment: """${
                                                values.comment
                                                  ? values.comment
                                                  : ''
                                              }"""
                                              , cellPhone: "${
                                                values.cellPhone
                                                  ? values.cellPhone
                                                  : ''
                                              }"
                                              , phone: "${
                                                values.phone ? values.phone : ''
                                              }"
                                              , active: ${values.active}
                                              , email: "${
                                                values.email ? values.email : ''
                                              }"
                                              , binds: {terms: ${JSON.stringify(
                                                terms
                                              ).replace(
                                                /"([^(")"]+)":/g,
                                                '$1:'
                                              )},
                                                        accessProfiles: ${JSON.stringify(
                                                          profiles
                                                        ).replace(
                                                          /"([^(")"]+)":/g,
                                                          '$1:'
                                                        )},
                                                        subjects: ${JSON.stringify(
                                                          subjects
                                                        ).replace(
                                                          /"([^(")"]+)":/g,
                                                          '$1:'
                                                        )},
                                                        channels: ${JSON.stringify(
                                                          channels
                                                        ).replace(
                                                          /"([^(")"]+)":/g,
                                                          '$1:'
                                                        )},
                                                        groups: ${JSON.stringify(
                                                          groups
                                                        ).replace(
                                                          /"([^(")"]+)":/g,
                                                          '$1:'
                                                        )},
                                                        classes: ${JSON.stringify(
                                                          classes
                                                        ).replace(
                                                          /"([^(")"]+)":/g,
                                                          '$1:'
                                                        )}
                                                        }
                                              , fileId: "${
                                                values.fileId
                                                  ? values.fileId
                                                  : ''
                                              }",          
                                              , usuarioChatInterno: false
                                              , ativo: true
                                              , filterByStatus: false
                                              , pedagogicAdm: false
                                              , updaterId: 0
                                              , usuarioChat: false
                                          }),
                              {id}
                          }`;
  return mutationQuery;
}

export function changePassEmployeeMutation(id, values) {
  const mutation = `mutation{changePassEmployee(id: ${id}, newPass: "${values.newPassword}" )}`;
  return mutation;
}

export function employeeList() {
  return `{
    employeeListByFilter(
      filter: {
        id: 0
        usuarioChatInterno: false
        ativo: false
        filterByStatus: true
        pedagogicAdm: false
        updaterId: 0
        usuarioChat: false
        active: true
      }
    ) {
      id
      name
    }
  }`;
}

export function relationCommunicationChannelEmployeeListByEmployeeId(
  employeeId
) {
  const query = `{
  relationCommunicationChannelEmployeeListByEmployeeId(employeeId: ${employeeId}) {
    id
    channel {
      id
      name
      unreadMessageQuantity
      active
    }
  }
}`;
  return query;
}

export function relationSubjectEmployeeListByEmployeeId(employeeId) {
  const query = `{
  relationSubjectEmployeeListByEmployeeId(employeeId: ${employeeId}) {
    id
    subject {
      id
      name
      termFilterId
      filterByStatus
      updaterId
      subjectLevelFilterId
      active
    }
    employee {
      id
      name
      usuarioChatInterno
      ativo
      filterByStatus
      pedagogicAdm
      updaterId
      usuarioChat
    }
  }
}`;
  return query;
}

export function relationGroupEmployeeListByEmployeeId(employeeId) {
  const query = `{
  relationGroupEmployeeListByEmployeeId(employeeId: ${employeeId}) {
    id
    channel {
      id
      name
    }
  }
}`;
  return query;
}

export function relationAccessProfileEmployeeListByEmployeeId(employeeId) {
  const query = `{
  relationAccessProfileEmployeeListByEmployeeId(employeeId: ${employeeId}) {
    id
    profile {
      id
      name
      accessToChat
      accessToInternal
      updaterId
    }
    employee {
      id
      name
    }
  }
}`;

  return query;
}

export function employeeRemove(id) {
  return `mutation {employeeRemove(id: ${id})}`;
}

export function employeeListBySubjectId(id) {
  return `{
       employeeListBySubject(
        subject: {
          id: ${id}, 
          termFilterId: 0, 
          filterByStatus: false, 
          updaterId: 0, 
          subjectLevelFilterId: 0, 
          active: false
        })
         {
           id
           name
         }
    }`;
}

export function relationEmployeeById(employeeId) {
  return `{
  employeeListByFilter(
    filter: {
      id: ${employeeId}
      usuarioChatInterno: false
      ativo: true
      filterByStatus: false
      pedagogicAdm: false
      updaterId: 0
      usuarioChat: false
      active: true
    }
  ) {
    id
    name
    fileUrl
  }
}
`;
}

export function employeeListActive(onlyActive) {
  return `{employeeListActive(onlyActive: ${onlyActive}){id, name, tipoFunc}}`;
}

export function getEmployeeIsAdmin() {
  return `{getEmployeeIsAdmin
    }`;
}

export function employeeListByFilter(filter) {
  return `{
  employeeListByFilter(
    filter: ${toStringify(filter)}
  ) {
    id
    name
    language
    cpf
    user
    password
    rg
    zipCode
    address
    addressNumber
    addressAdjunct
    neighborhood
    comment
    cellPhone
    phone
    active
    email
    fileUrl
    fileId
    usuarioChatInterno
    ativo
    filterByStatus
    pedagogicAdm
    updaterId
    usuarioChat
    accessProfiles
  }
}`;
}
